import React, { useContext, useState } from 'react';
import { ShopContext } from '../../context/shop-context';
import { Trash } from 'phosphor-react';
import { Heart } from 'phosphor-react';
import Modal from 'react-modal';
import { Minus } from 'phosphor-react';
import { Plus } from 'phosphor-react';


Modal.setAppElement('#root');

function CartItem(props) {
// Destructuring props to extract specific properties
const { id, productName, productDetail, price, productImage } = props.data;

// Getting cart-related functions and state from context
const { cartItems, addToCart, removeFromCart, updateCartItemCount } = useContext(ShopContext);

// State for displaying confirmation dialog
const [showConfirmation, setShowConfirmation] = useState(false);

// Handler for initiating removal from cart
const handleRemoveFromCart = (id) => {
  setShowConfirmation(true); // Show confirmation dialog
};

// Handler for confirming removal from cart
const confirmRemoveFromCart = (id) => {
  removeFromCart(id); // Remove item from cart
  setShowConfirmation(false); // Hide confirmation dialog
};

// Handler for canceling removal from cart
const cancelRemoveFromCart = () => {
  setShowConfirmation(false); // Hide confirmation dialog
};

  

  return (
    <div className="cartItem">
  <img src={productImage} alt={productName} />
  <div className="description">
    <p>
      <b>{productName}</b>
    </p>
    <p>${price}</p>
    <div className="cart-container">
      <button className="custom-button" onClick={()=> handleRemoveFromCart(id)}>
        <Trash />
      </button>
      <div className="countHandler">
        <button className="custom-button" aria-label="delete" onClick={()=> removeFromCart(id)}>
          <Minus />
        </button>

        <input value={cartItems[id]} onChange={(e)=> updateCartItemCount(Number(e.target.value), id)} />
        <button className="custom-button" aria-label="add" onClick={()=> addToCart(id)}>
          <Plus />
        </button>

      </div>
    </div>
  </div>

      <Modal
        isOpen={showConfirmation}
        onRequestClose={cancelRemoveFromCart}
        contentLabel="Confirmation Modal"
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
          },
          content: {
            width: '400px',
            height: '100px',
            overflowY: "hidden",
            margin: 'auto',
            background: 'white',
            border: '1px solid #ccc',
            borderRadius: '4px',
            padding: '20px'
          }
        }}
      >
        <div className="confirmation-modal">
          <p className='modaltitle'>Are you sure you want to remove this item?</p>
          <div className='modalquestions'>
          <button className="custom-button" onClick={() => confirmRemoveFromCart(id)}><Trash/>Delete</button>
          <button className="custom-button" onClick={() => cancelRemoveFromCart(id)}><Heart/>Keep </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default CartItem;
